import React from "react"
import { ReflectionActionsEnum } from "../../Shared/ReflectionActionsEnum"
import classes from './ReflectionLikeType.module.css'
import Lines from '../../../assests/reflection/lines.png';
import LikeIcon from '../../../assests/reflection/like.png';
import DisIcon from '../../../assests/reflection/disLike.png';
import emptyLike from '../../../assests/reflection/empty-like.png';
import emptyDisLike from '../../../assests/reflection/empty-dislike.png';
import { ReflectionLikeOptionEnum } from "../../Shared/ReflectionLikeOptionEnum";
import { calculatePercentage } from "../../Shared/ReportPercentageCalculation";

const ReflectionLikeType = ({ action, question, isStudent, answerValue, setAnswerValue }) => {

    switch (action) {

        case ReflectionActionsEnum.CRUD:
            return (
                <div className={classes.CreateType}>
                    <div className={classes.Text}>{question && question.text ? question.text : <img className={classes.Lines} src={Lines} />}</div>
                    <div className={classes.Thumbs}>
                        <img src={LikeIcon} className={classes.LikeIcon} />
                        <img src={DisIcon} />
                    </div>
                </div>
            )

        case ReflectionActionsEnum.View:
            return (<div className={classes.CreateType}>
                <div className={classes.Text}>{question && question.text ? question.text : <img className={classes.Lines} src={Lines} />}</div>
                <div className={`${classes.Thumbs} ${isStudent && classes.ThumbsView}`}>
                    <img src={answerValue === ReflectionLikeOptionEnum.Like || !isStudent ? LikeIcon : emptyLike} className={classes.LikeIcon} onClick={() => isStudent && setAnswerValue(ReflectionLikeOptionEnum.Like)} />
                    <img src={answerValue === ReflectionLikeOptionEnum.DisLike || !isStudent ? DisIcon : emptyDisLike} onClick={() => isStudent && setAnswerValue(ReflectionLikeOptionEnum.DisLike)} />
                </div>
            </div>)

        case ReflectionActionsEnum.Report:
            const answers = calculatePercentage(question.submissions, 2)
            return (
                <div className={classes.ReportType}>
                    <p className={classes.ReportQuestion}>{question.name}</p>
                    <div className={classes.PrecentsBar}>
                        <img src={DisIcon} />
                        <div
                            className={classes.ReportLine}
                            style={{ background: `linear-gradient(to right, #FF5E5E ${answers[0].percentage}%, #73DED8 ${answers[0].percentage}%)` }} />
                        <img src={LikeIcon} className={classes.LikeIcon} />
                    </div>
                </div>)

        default:
            return null
    }

}

export default ReflectionLikeType
